import React, { useEffect, useState } from "react";
import Footer from "../Components/Footer/footer";
import { useNavigate } from "react-router";
import performRequest from "../api/request";
import Pagination from "../Components/layouts/pagination";
import { useSelector } from "react-redux";
import { FcBusiness, FcNext } from "react-icons/fc";
import { Toast } from "../CustomComponent/toast";

import getFilteredURL from "../Components/Functions/filters.getUrl";
import { set } from "date-fns";
import StepRoutes from "../Routes/steps_routes";

// ================= FILTER GROUPS (LOGIC ONLY) =================
const filterGroups = [
  {
    category: "Performance",
    items: ["Highest Accuracy", "Best Score per Attempt"],
  },
  {
    category: "Consistency",
    items: ["Most Consistent", "Never Missed", "On Fire"],
  },
  {
    category: "Growth",
    items: ["Fastest Improvers", "Most Engaged"],
  },
];

const GetTestDetails = () => {
  const userDetails = useSelector((store) => store.login.user);
  const navigate = useNavigate();
  const [remainingTestAttempts, setRemainingAttempts] = useState(false);

  const [leaderBoard, setLeaderBoard] = useState([]);
  const [yearlyLeaderBoard, setYearlyLeaderBoard] = useState([]);
  const [monthlyLeaderboard, setMonthlyLeaderboard] = useState([]);
  const [yearlyLeaderboard, setYearlyLeaderboard] = useState([]);

  /* ===== FILTERED STATES ===== */
  const [monthlyMostConsistent, setMonthlyMostConsistent] = useState([]);
  const [yearlyMostConsistent, setYearlyMostConsistent] = useState([]);

  const [monthlyNeverMissed, setMonthlyNeverMissed] = useState([]);
  const [yearlyNeverMissed, setYearlyNeverMissed] = useState([]);

  const [monthlyHighestAccuracy, setMonthlyHighestAccuracy] = useState([]);
  const [yearlyHighestAccuracy, setYearlyHighestAccuracy] = useState([]);

  const [monthlyMostEngaged, setMonthlyMostEngaged] = useState([]);
  const [yearlyMostEngaged, setYearlyMostEngaged] = useState([]);

  const [monthlyBestScore, setMonthlyBestScore] = useState([]);
  const [yearlyBestScore, setYearlyBestScore] = useState([]);

  const [monthlyOneShot, setMonthlyOneShot] = useState([]);
  const [yearlyOneShot, setYearlyOneShot] = useState([]);

  const [monthlyFastestImprovers, setMonthlyFastestImprovers] = useState([]);
  const [yearlyFastestImprovers, setYearlyFastestImprovers] = useState([]);

  const [monthlyOnFire, setMonthlyOnFire] = useState([]);
  const [yearlyOnFire, setYearlyOnFire] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [refresh, setRefresh] = useState(false);

  // ================= FILTER STATE (CAREER STYLE) =================
  const [filters, setFilters] = useState({
    leaderboardFilters: [],
  });

  const selectedFilters = filters.leaderboardFilters;
  const totalFilters = filterGroups.flatMap((g) => g.items).length;

  // ================= FILTER HANDLERS =================
  const toggleFilter = (value) => {
    setFilters((prev) => ({
      leaderboardFilters: prev.leaderboardFilters.includes(value)
        ? prev.leaderboardFilters.filter((v) => v !== value)
        : [...prev.leaderboardFilters, value],
    }));
    setPage(1);
  };

  const handleSelectAll = (checked) => {
    const all = filterGroups.flatMap((g) => g.items);
    setFilters({
      leaderboardFilters: checked ? all : [],
    });
    setPage(1);
  };

  // ================= API CALL (SAME AS CAREER FILTER) =================
  useEffect(() => {
    setFilters({
      leaderboardFilters: selectedFilters,
    });
    performRequest(
      "GET",
      getFilteredURL("/test/get-score-card-leader-board", page, filters)
    )
      .then((res) => {
        if (res?.status === 200) {
          setLeaderBoard(res.data?.monthlyLeaderboard || []);
          setYearlyLeaderBoard(res.data?.yearlyLeaderboard || []);
          setTotalPages(Math.ceil((res.data?.totalCount || 1) / 10));
          const data = res?.data;

          // /* ================= BASE LEADERBOARDS ================= */
          // setMonthlyLeaderboard(data?.monthlyLeaderboard ?? []);
          // setYearlyLeaderboard(data?.yearlyLeaderboard ?? []);

          /* ================= FILTERED : MOST CONSISTENT ================= */
          setMonthlyMostConsistent(
            data?.monthlyLeaderboardMostConsistent ?? []
          );
          setYearlyMostConsistent(data?.yearlyLeaderboardMostConsistent ?? []);

          /* ================= FILTERED : NEVER MISSED ================= */
          setMonthlyNeverMissed(data?.monthlyLeaderboardNeverMissed ?? []);
          setYearlyNeverMissed(data?.yearlyLeaderboardNeverMissed ?? []);

          /* ================= FILTERED : HIGHEST ACCURACY ================= */
          setMonthlyHighestAccuracy(
            data?.monthlyLeaderboardHighestAccuracy ?? []
          );
          setYearlyHighestAccuracy(
            data?.yearlyLeaderboardHighestAccuracy ?? []
          );

          /* ================= FILTERED : MOST ENGAGED ================= */
          setMonthlyMostEngaged(data?.monthlyLeaderboardMostEngaged ?? []);
          setYearlyMostEngaged(data?.yearlyLeaderboardMostEngaged ?? []);

          /* ================= FILTERED : BEST SCORE ================= */
          setMonthlyBestScore(
            data?.monthlyLeaderboardBestScoreperAttempt ?? []
          );
          setYearlyBestScore(data?.yearlyLeaderboardBestScoreperAttempt ?? []);

          /* ================= FILTERED : ONE-SHOT WONDERS ================= */
          setMonthlyOneShot(data?.monthlyLeaderboardOneShotWonders ?? []);
          setYearlyOneShot(data?.yearlyLeaderboardOneShotWonders ?? []);

          /* ================= FILTERED : FASTEST IMPROVERS ================= */
          setMonthlyFastestImprovers(
            data?.monthlyLeaderboardFastestImprovers ?? []
          );
          setYearlyFastestImprovers(
            data?.yearlyLeaderboardFastestImprovers ?? []
          );

          /* ================= FILTERED : ON FIRE ================= */
          setMonthlyOnFire(data?.monthlyLeaderboardOnFire ?? []);
          setYearlyOnFire(data?.yearlyLeaderboardOnFire ?? []);
        } else {
          Toast("error", "Failed to load leaderboard");
        }
      })
      .catch((err) => {
        // CustomErrorResponse(err);
        console.log(err);
      });
  }, [page, refresh]);

  // ================= RANK COLOR =================
  const getRankBg = (rank) => {
    if (rank === 1) return "bg-lime-lt";
    if (rank === 2) return "bg-green-lt";
    if (rank === 3) return "bg-teal-lt";
    return "bg-secondary-lt";
  };
  // GET REMAINING TRAINEE TEST ATTEMTP DASHBOARD

  useEffect(() => {
    performRequest(
      "GET",
      `/test/remaining-test-attempts/${userDetails?.UserId}`
    )
      .then((res) => {
        setRemainingAttempts(res?.data?.attemptsLeft);
      })
      .catch((err) => {
        console.log(err, "error fetching remaining attempts");
      });
  }, []);

  return (
    <div className="Page">
      <div className="page-wrapper">
        <div className="page-body">
          <div className="container-xxl">
            <div className="row align-items-center mb-3">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcBusiness className="fs-2  me-1" /> EARN YOUR RANK
                </h2>
                <h4 className="text-muted">Master What Matters</h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <div className="text-end mb-2">
                    {remainingTestAttempts > 0 && (
                      <button
                        onClick={() =>
                          navigate(`/trainee-tests/${userDetails?.UserId}`)
                        }
                        className="btn btn-outline-yellow me-2"
                      >
                        Trainee Pending Test : {remainingTestAttempts}{" "}
                        {/* <FcNext color="yellow" background="white" /> */}
                      </button>
                    )}
                    <button
                      onClick={() =>
                        navigate(
                          `/employee-test-overview/${userDetails?.UserId}`
                        )
                      }
                      className="btn btn-outline-primary me-2"
                    >
                      My Overview <FcNext />
                    </button>

                    <button
                      onClick={() => {
                        const confirmed = window.confirm(
                          "Do you want to proceed for test?"
                        );

                        if (confirmed) {
                          navigate(`/internal-test/${userDetails?.UserId}`);
                        }
                      }}
                      className="btn btn-primary"
                    >
                      Next Evaluation <FcNext />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row row-cards">
              <div className="col-12">
                <div className="row">
                  {/* ================= FILTER CARD (UNCHANGED UI) ================= */}
                  <div className="col-md-3 col-sm-12">
                    <div className="card p-2">
                      <div
                        id="faq-1"
                        className="accordion"
                        role="tablist"
                        aria-multiselectable="true"
                      >
                        <div>
                          {/* MOBILE HEADER */}
                          <div
                            className="accordion-header m-0 d-md-none"
                            role="tab"
                          >
                            <button
                              className="accordion-button fs-3 p-0"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq-1-1"
                            >
                              <h3 className="m-1">Leaderboard Filters</h3>
                            </button>
                          </div>

                          {/* MOBILE BODY */}
                          <div
                            id="faq-1-1"
                            className="accordion-collapse collapse d-md-none"
                            role="tabpanel"
                            data-bs-parent="#faq-1"
                          >
                            <div className="accordion-body pt-0">
                              {/* Selected Filters */}
                              <div className="mb-2">
                                {selectedFilters.map((item, index) => (
                                  <span key={index} className="m-1 tag">
                                    {item}
                                    <span
                                      className="btn-close ms-1 cursor-pointer"
                                      onClick={() => toggleFilter(item)}
                                    />
                                  </span>
                                ))}
                              </div>

                              {/* Select All */}
                              <div className="form-check mb-2">
                                <input
                                  className="form-check-input cursor-pointer"
                                  type="checkbox"
                                  checked={
                                    selectedFilters.length === totalFilters
                                  }
                                  onChange={(e) =>
                                    handleSelectAll(e.target.checked)
                                  }
                                />
                                <label className="form-check-label fs-4">
                                  Select All
                                  <span className="badge bg-blue-lt ms-2">
                                    {selectedFilters.length}
                                  </span>
                                </label>
                              </div>

                              {/* FILTER GROUPS */}
                              {filterGroups.map((group) => (
                                <div key={group.category} className="mb-2">
                                  <div className="fw-bold text-muted mb-1">
                                    {group.category}
                                  </div>

                                  {group.items.map((item) => (
                                    <div key={item} className="form-check">
                                      <input
                                        className="form-check-input cursor-pointer"
                                        type="checkbox"
                                        checked={selectedFilters.includes(item)}
                                        onChange={() => toggleFilter(item)}
                                      />
                                      <label className="form-check-label fs-4">
                                        {item}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              ))}

                              {/* ACTION BUTTONS */}
                              <div className="row mt-3">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({ leaderboardFilters: [] });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* DESKTOP VIEW */}
                          <div className="accordion-body d-none d-md-block">
                            <h3 className="mb-2">Leaderboard Filters</h3>

                            {/* Selected Filters */}
                            <div className="mb-2">
                              {selectedFilters.map((item, index) => (
                                <span key={index} className="m-1 tag">
                                  {item}
                                  <span
                                    className="btn-close ms-1 cursor-pointer"
                                    onClick={() => toggleFilter(item)}
                                  />
                                </span>
                              ))}
                            </div>

                            {/* Select All */}
                            <div className="form-check mb-2">
                              <input
                                className="form-check-input cursor-pointer"
                                type="checkbox"
                                checked={
                                  selectedFilters.length === totalFilters
                                }
                                onChange={(e) =>
                                  handleSelectAll(e.target.checked)
                                }
                              />
                              <label className="form-check-label fs-4">
                                Select All
                                <span className="badge bg-blue-lt ms-2">
                                  {selectedFilters.length}
                                </span>
                              </label>
                            </div>

                            {/* FILTER GROUPS */}
                            {filterGroups.map((group) => (
                              <div key={group.category} className="mb-2">
                                <div className="fw-bold text-muted mb-1">
                                  {group.category}
                                </div>

                                {group.items.map((item) => (
                                  <div key={item} className="form-check">
                                    <input
                                      className="form-check-input cursor-pointer"
                                      type="checkbox"
                                      checked={selectedFilters.includes(item)}
                                      onChange={() => toggleFilter(item)}
                                    />
                                    <label className="form-check-label fs-4">
                                      {item}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            ))}

                            {/* ACTION BUTTONS */}
                            <div className="row mt-3">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({ leaderboardFilters: [] });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ================= LEADERBOARD UI (UNCHANGED) ================= */}
                  <div className="col-lg-9 col-md-8">
                    <div className="card">
                      <div className="m-3">
                        <h1>The Rankings</h1>
                        <p>Consistency builds excellence.</p>
                      </div>
                      <hr className="mt-0" />

                      <div className="card-body fs-4">
                        {(monthlyHighestAccuracy?.length > 0 ||
                          yearlyHighestAccuracy?.length > 0) && (
                          <div className="row m-1">
                            {/* ================= MONTHLY FILTERED ================= */}
                            <div className="col-12 col-md-6 mb-4 mb-md-0">
                              <h5 className="mb-3 fs-3">
                                Monthly · Highest Accuracy
                              </h5>

                              <div className="row row-deck row-cards">
                                {monthlyHighestAccuracy?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* ================= YEARLY FILTERED ================= */}
                            <div className="col-12 col-md-6">
                              <h5 className="mb-3 fs-3">
                                Yearly · Highest Accuracy
                              </h5>

                              <div className="row row-deck row-cards">
                                {monthlyHighestAccuracy?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                        {(monthlyBestScore?.length > 0 ||
                          yearlyBestScore?.length > 0) && (
                          <div className="row m-1">
                            {/* ================= MONTHLY FILTERED ================= */}
                            <div className="col-12 col-md-6 mb-4 mb-md-0">
                              <h5 className="mb-3 fs-3">
                                Monthly · Best Score Per Attempt
                              </h5>

                              <div className="row row-deck row-cards">
                                {monthlyBestScore?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* ================= YEARLY FILTERED ================= */}
                            <div className="col-12 col-md-6">
                              <h5 className="mb-3 fs-3">
                                Yearly · Best Score Per Attempt
                              </h5>

                              <div className="row row-deck row-cards">
                                {yearlyBestScore?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                        {(monthlyMostConsistent?.length > 0 ||
                          yearlyMostConsistent?.length > 0) && (
                          <div className="row m-1">
                            {/* ================= MONTHLY FILTERED ================= */}
                            <div className="col-12 col-md-6 mb-4 mb-md-0">
                              <h5 className="mb-3 fs-3">
                                Monthly · Most Consistent
                              </h5>

                              <div className="row row-deck row-cards">
                                {monthlyMostConsistent?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* ================= YEARLY FILTERED ================= */}
                            <div className="col-12 col-md-6">
                              <h5 className="mb-3 fs-3">
                                Yearly · Most Consistent
                              </h5>

                              <div className="row row-deck row-cards">
                                {yearlyMostConsistent?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                        {(monthlyNeverMissed?.length > 0 ||
                          yearlyNeverMissed?.length > 0) && (
                          <div className="row m-1">
                            {/* ================= MONTHLY FILTERED ================= */}
                            <div className="col-12 col-md-6 mb-4 mb-md-0">
                              <h5 className="mb-3 fs-3">
                                Monthly · Never Missed
                              </h5>

                              <div className="row row-deck row-cards">
                                {monthlyNeverMissed?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* ================= YEARLY FILTERED ================= */}
                            <div className="col-12 col-md-6">
                              <h5 className="mb-3 fs-3">
                                Yearly · Never Missed
                              </h5>

                              <div className="row row-deck row-cards">
                                {yearlyNeverMissed?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                        {(monthlyOnFire?.length > 0 ||
                          yearlyOnFire?.length > 0) && (
                          <div className="row m-1">
                            {/* ================= MONTHLY FILTERED ================= */}
                            <div className="col-12 col-md-6 mb-4 mb-md-0">
                              <h5 className="mb-3 fs-3">Monthly · On Fire</h5>

                              <div className="row row-deck row-cards">
                                {monthlyOnFire?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* ================= YEARLY FILTERED ================= */}
                            <div className="col-12 col-md-6">
                              <h5 className="mb-3 fs-3">Yearly · On Fire</h5>

                              <div className="row row-deck row-cards">
                                {yearlyOnFire?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                        {(monthlyFastestImprovers?.length > 0 ||
                          yearlyFastestImprovers?.length > 0) && (
                          <div className="row m-1">
                            {/* ================= MONTHLY FILTERED ================= */}
                            <div className="col-12 col-md-6 mb-4 mb-md-0">
                              <h5 className="mb-3 fs-3">
                                Monthly · Fastest Improvers
                              </h5>

                              <div className="row row-deck row-cards">
                                {monthlyFastestImprovers?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* ================= YEARLY FILTERED ================= */}
                            <div className="col-12 col-md-6">
                              <h5 className="mb-3 fs-3">
                                Yearly · Fastest Improvers
                              </h5>

                              <div className="row row-deck row-cards">
                                {yearlyFastestImprovers?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                        {(monthlyMostEngaged?.length > 0 ||
                          yearlyMostEngaged?.length > 0) && (
                          <div className="row m-1">
                            {/* ================= MONTHLY FILTERED ================= */}
                            <div className="col-12 col-md-6 mb-4 mb-md-0">
                              <h5 className="mb-3 fs-3">
                                Monthly · Most Engaged
                              </h5>

                              <div className="row row-deck row-cards">
                                {monthlyMostEngaged?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>

                            {/* ================= YEARLY FILTERED ================= */}
                            <div className="col-12 col-md-6">
                              <h5 className="mb-3 fs-3">
                                Yearly · Most Engaged
                              </h5>

                              <div className="row row-deck row-cards">
                                {yearlyMostEngaged?.map((user, i) => (
                                  <div className="col-12 mb-3" key={i}>
                                    <div
                                      className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                        user?.rank || i + 1
                                      )}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-between flex-wrap">
                                        {/* USER INFO */}
                                        <div className="d-flex align-items-center">
                                          <span
                                            className="avatar avatar-md rounded-circle me-3"
                                            style={{
                                              backgroundImage: `url(${
                                                user?.user?.photograph ||
                                                "/default-user.png"
                                              })`,
                                            }}
                                          />
                                          <div>
                                            <div className="fw-semibold">
                                              {user?.user?.userName?.substring(
                                                0,
                                                15
                                              )}
                                            </div>
                                            <div className="text-muted fs-7">
                                              Attempts: {user?.attempts}
                                            </div>
                                          </div>
                                        </div>

                                        {/* STATS */}
                                        <div className="d-flex gap-3 text-center">
                                          <div>
                                            <div className="text-muted fs-7">
                                              Rank
                                            </div>
                                            <div className="fw-bold">
                                              #{user?.rank}
                                            </div>
                                          </div>
                                          <div>
                                            <div className="text-muted fs-7">
                                              Points
                                            </div>
                                            <div className="fw-bold">
                                              {user?.totalScore}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="row m-1">
                          {/* Monthly Leaderboard */}
                          <div className="col-12 col-md-6 mb-4 mb-md-0">
                            <h5 className="mb-3 fs-3">Monthly Leaderboard</h5>
                            <div className="row row-deck row-cards">
                              {leaderBoard.map((user, i) => (
                                <div className="col-12 mb-3" key={i}>
                                  <div
                                    className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                      user?.rank || i + 1
                                    )}`}
                                  >
                                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                                      {/* LEFT : USER INFO */}
                                      <div className="d-flex align-items-center mb-2 mb-md-0">
                                        <span
                                          className="avatar avatar-md rounded-circle me-3"
                                          style={{
                                            backgroundImage: `url(${
                                              user?.user?.photograph ||
                                              "/default-user.png"
                                            })`,
                                          }}
                                        />
                                        <div>
                                          <div className="fw-semibold">
                                            {user?.user?.userName.substring(
                                              0,
                                              15
                                            )}
                                          </div>
                                          <div className="text-muted fs-7">
                                            {user?.department || "Employee"}
                                          </div>
                                        </div>
                                      </div>

                                      {/* CENTER : STATS */}
                                      <div className="d-flex align-items-center gap-3 text-center flex-wrap mb-2 mb-md-0">
                                        <div>
                                          <div className="text-muted fs-7">
                                            Rank
                                          </div>
                                          <div className="fw-bold">
                                            #{user?.rank || i + 1}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-muted fs-7">
                                            Points
                                          </div>
                                          <div className="fw-bold">
                                            {user?.totalScore || 0}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-muted fs-7">
                                            Status
                                          </div>
                                          <span className="badge bg-lime-lt">
                                            {user?.status || "Active"}
                                          </span>
                                        </div>
                                      </div>

                                      {/* RIGHT : ACTION */}
                                      <div>
                                        <button
                                          onClick={() =>
                                            navigate(
                                              `/employee-test-overview/${user?.user?.id}`
                                            )
                                          }
                                          className="btn btn-outline-primary btn-sm rounded-2"
                                        >
                                          View
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Yearly Leaderboard */}
                          <div className="col-12 col-md-6">
                            <h5 className="mb-3 fs-3">Yearly Leaderboard</h5>
                            <div className="row row-deck row-cards">
                              {yearlyLeaderBoard.map((user, i) => (
                                <div className="col-12 mb-3" key={i}>
                                  <div
                                    className={`card rounded-2 shadow-sm p-2 ${getRankBg(
                                      user?.rank || i + 1
                                    )}`}
                                  >
                                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                                      {/* LEFT : USER INFO */}
                                      <div className="d-flex align-items-center mb-2 mb-md-0">
                                        <span
                                          className="avatar avatar-md rounded-circle me-3"
                                          style={{
                                            backgroundImage: `url(${
                                              user?.user?.photograph ||
                                              "/default-user.png"
                                            })`,
                                          }}
                                        />
                                        <div>
                                          <div className="fw-semibold">
                                            {/* {user?.user?.userName} */}
                                            {user?.user?.userName.substring(
                                              0,
                                              15
                                            )}
                                          </div>
                                          <div className="text-muted fs-7">
                                            {user?.department || "Employee"}
                                          </div>
                                        </div>
                                      </div>

                                      {/* CENTER : STATS */}
                                      <div className="d-flex align-items-center gap-3 text-center flex-wrap mb-2 mb-md-0">
                                        <div>
                                          <div className="text-muted fs-7">
                                            Rank
                                          </div>
                                          <div className="fw-bold">
                                            #{user?.rank || i + 1}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-muted fs-7">
                                            Points
                                          </div>
                                          <div className="fw-bold">
                                            {user?.totalScore || 0}
                                          </div>
                                        </div>
                                        <div>
                                          <div className="text-muted fs-7">
                                            Status
                                          </div>
                                          <span className="badge bg-lime-lt">
                                            {user?.status || "Active"}
                                          </span>
                                        </div>
                                      </div>

                                      {/* RIGHT : ACTION */}
                                      <div>
                                        <button
                                          onClick={() =>
                                            navigate(
                                              `/employee-test-overview/${user?.user?.id}`
                                            )
                                          }
                                          className="btn btn-outline-primary btn-sm rounded-2"
                                        >
                                          View
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>

                            <Pagination
                              currentPage={page}
                              totalPages={totalPages}
                              onPageChange={setPage}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default GetTestDetails;
